export default __webpack_public_path__ + "static/media/Panel_-_Stage1.41777a81.svg";